import { useState, useEffect } from "react"

type Theme = "light" | "dark"

function getInitialTheme(): Theme {
  if (typeof window === "undefined") return "light"
  const saved = localStorage.getItem("fincontrol-theme") as Theme | null
  if (saved === "light" || saved === "dark") return saved
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitialTheme)

  useEffect(() => {
    const root = document.documentElement
    root.classList.remove("light", "dark")
    root.classList.add(theme)
    localStorage.setItem("fincontrol-theme", theme)
  }, [theme])

  const toggle = () => setTheme(t => (t === "light" ? "dark" : "light"))

  return { theme, toggle, isDark: theme === "dark" }
}
